import { render, staticRenderFns } from "./export-sale-invoice-clone-dialog.vue?vue&type=template&id=8c63ff8a&scoped=true"
import script from "./export-sale-invoice-clone-dialog.vue?vue&type=script&lang=js"
export * from "./export-sale-invoice-clone-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c63ff8a",
  null
  
)

export default component.exports